<template>
  <div class="profile-page first_page" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <section class="section" v-if="isload">
      <div class="container-fluid ">
        <div class="col-12 col-md-6 col-lg-6">
          <UserCard   :user="developer" />
        </div>
        <div class="row mt-3 mb-3 ml-3">

            <button class="btn btn-active" v-if="count_works>0"  >Все работы</button>
            <router-link class="btn" v-if="count_reviews>0" :to="{name: 'reviewpage', params: { username: this.developer.username }}" tag="a">Отзывы</router-link>
            <router-link class="btn" tag="a" v-if="developer.isshop && developer.isshop==1 && developer.shop_setting &&  developer.shop_setting.status && developer.shop_setting.status=='on' && count_items>0" :to="{name: 'developer_catalog', params: { username: this.developer.username }}">Каталог</router-link>

        </div>
        <div class="row">
          <vue-timeline-update @click="clickWork(work)" v-for="work in developer.portfolio" :key="work.last_id"
                               :date="new Date(work.date_start)"
                               :title="work.name"
                               :description="work.description+'<br>'+more_btn"
                               :thumbnail="work.image"
                               :category="work.category.name"
                               icon="code"
                               color="red"
          />
        </div>
      </div>
    </section>


  </div>
</template>
<script>
import {eventBus} from "@/main";
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";
import Editorjsrender from "@/models/Editorjsrender";
import UserCard from "@/components/Custom/UserCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";
var Avatar = require('vue-avatar')

export default {
  name: "developer",
  data() {
    return {
      'more_btn': '<button  class="btn">Посмотреть работу</button>',
      "isload": false,
      'developer': {},
      'image_url': null,
      'count_reviews':0,
      'count_works':0,
      'count_items':0,

    }
  },
  mounted() {
    var app=this;
    Api.loadDeveloperv2(this.$route.params.username,function(data){
     app.image_url = Vue.config.IMAGE_URL;
      app.developer = data.developer;
      app.count_works=data.count_works;
      app.count_reviews=data.count_reviews;
      app.count_items=data.count_items;

      app.isload = true;
    },function(){
      app.$router.push({name:'404'});
    })

  },
  methods: {
    clickWork(work) {

      this.$router.push({name: 'user_page_one_portfolio', params: {user_id: this.developer.last_id, "work_id": work.last_id}});
    }
  },
  components: {

     'UserCard':UserCard,
    'avatar': Avatar.Avatar,
    LoadingBlock
  }
};
</script>
<style>
</style>
